import React from 'react';
import OpenAccount from '../OpenAccount';
import Hero from './Hero';
import Brokerage from './Brokerage';

function PricingPage() {
    return ( 
        <>
            <Hero/>
           
            <Brokerage/>
        </>
     );
}

export default PricingPage;